export enum ServerMessage {
  TRIGGER_EXECUTED = 'trigger-executed',
};